/**
 * Line-by-line comparison of two multi-line values. Pure.
 *
 * Ported from V1's `features/quotation-detail/core/diff.ts`, and deliberately
 * this crude: it flags which *lines* differ, so the two columns can highlight
 * them, and it does not attempt a word-level diff. Two readings produced
 * independently disagree constantly in wording, and a character diff would
 * paint every one of those as though it were a difference in meaning -- which
 * is exactly the noise the nine checks exist to filter out.
 */

export interface DiffLine {
  readonly text: string
  readonly differs: boolean
}

/**
 * Both sides, padded to the same length so the columns stay in step. An empty
 * line against a non-empty one always differs.
 */
export function diffLines(
  prescription: string,
  system: string,
): { prescriptionLines: DiffLine[]; systemLines: DiffLine[] } {
  const left = prescription.split('\n')
  const right = system.split('\n')
  const length = Math.max(left.length, right.length)

  const prescriptionLines: DiffLine[] = []
  const systemLines: DiffLine[] = []

  for (let i = 0; i < length; i += 1) {
    const p = left[i] ?? ''
    const s = right[i] ?? ''
    const differs = p.trim() !== s.trim()
    prescriptionLines.push({ text: p, differs })
    systemLines.push({ text: s, differs })
  }

  return { prescriptionLines, systemLines }
}
